












































































import * as _ from 'lodash'
import { Vue, Prop, Component, Provide } from 'vue-property-decorator'
import { IDialogOption } from '@/store/modules/components/states'
import { BaseForm } from '@/services/BaseForm'

@Component
export default class DialogComponent extends BaseForm<any> {
  @Provide('formName') public formName = (this.$parent as any).formName
  @Prop({ default: false }) private value!: boolean
  @Prop({ default: false }) private fullscreen!: boolean
  @Prop({ default: 650 }) private width!: number
  @Prop({ default: 650 }) private height!: number
  @Prop() private title!: string
  @Prop() private color!: string
  @Prop() private dialogOption!: IDialogOption
  @Prop({ default: true }) private action!: boolean

  get getDialogOption() {
    return this.dialogOption
  }

  get justify() {
    return this.getDialogOption && this.getDialogOption.justify
      ? this.getDialogOption.justify
      : 'start'
  }

  get justifyButton() {
    return this.getDialogOption && this.getDialogOption.button && this.getDialogOption.button.justify
      ? this.getDialogOption.button.justify
      : 'start'
  }

  get modal() {
    return this.value
  }

  set modal(val: boolean) {
    this.$emit('input', val)
  }

  get buttonName() {
    const button = _.chain(this.getDialogOption.button)
      .keys()
      .filter((item: string) => _.includes(item, 'Button'))
      .value()
    return this.$vuetify.breakpoint.smAndDown ? _.reverse(button) : button
  }

  private closeModal() {
    this.modal = false
  }

  private async actionButtonFunc(name) {
    let result: boolean
    if (this.getDialogOption.button[name].action) {
      const isValidate = !this.getDialogOption.button[name].notValidate && this.getDialogOption.form
        ? this.getDialogOption.form.validate()
        : true
      if (isValidate) {
        result = await this.getDialogOption.button[name].action()
      } else {
        if (!_.includes(name, 'cancel')) {
          this.updateSnackbar({txt: 'กรุณากรอกข้อมูลให้ถูกต้อง', type: 'error'})
          result = false
        } else {
          result = true
        }
      }
    }
    if (result !== false) {
      this.closeModal()
    }
  }
}
